import React, { Component } from 'react'

// Libraries
import { Layout } from 'antd'
// import PropTypes from 'prop-types'

const { Footer } = Layout

class CustomFooter extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <Footer>
        Made with <span style={{ color: 'red' }}>â¤</span> by{' '}
        <a href='https://www.insightnest.fr/' target='_blank' rel='noopener noreferrer'>InsightNest</a>
      </Footer>
    )
  }
}

export default CustomFooter
